"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon/APIcon"));
var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));
var _EnableModal = _interopRequireDefault(require("./EnableModal"));
var _DisableModal = _interopRequireDefault(require("./DisableModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('trade-settings');
var MarginTradingSetting = function MarginTradingSetting(_ref) {
  var enabled = _ref.enabled,
    accountStatus = _ref.accountStatus,
    text = _ref.text,
    openEnableModal = _ref.openEnableModal,
    openDisableModal = _ref.openDisableModal,
    cardText = _ref.cardText,
    disabled = _ref.disabled;
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: themeClasses('box')
  }, !accountStatus && /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "alert"
  }), /*#__PURE__*/_react["default"].createElement("header", {
    className: themeClasses('box-header')
  }, /*#__PURE__*/_react["default"].createElement("span", null, t("Interest Bearing Accounts"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "divider"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('box-body')
  }, /*#__PURE__*/_react["default"].createElement("p", null, t("Apply to earn passive income on your deposits of selected products. Restrictions apply.")), /*#__PURE__*/_react["default"].createElement("p", {
    className: themeClasses('status')
  }, t("Lending is"), /*#__PURE__*/_react["default"].createElement("strong", null, " ", t(text)), '.'), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    customClass: "".concat(themeClasses('submit-button'), " ").concat(text),
    onClick: enabled === 'disabled' ? openEnableModal : openDisableModal,
    disabled: disabled || accountStatus === 'Pending'
  }, /*#__PURE__*/_react["default"].createElement("span", null, accountStatus === 'Pending' ? t("Pending") : enabled === 'enabled' ? t("Disable") : t("Enable"))))), /*#__PURE__*/_react["default"].createElement(_EnableModal["default"], null), /*#__PURE__*/_react["default"].createElement(_ConfirmationModal["default"], null), /*#__PURE__*/_react["default"].createElement(_DisableModal["default"], null));
};
MarginTradingSetting.defaultProps = {
  enabled: 'disabled'
};
var _default = exports["default"] = MarginTradingSetting;